/**
 * Determines if dev warning should be displayed based on user role and environment
 * @param {Object} user - The user object with roles array
 * @returns {boolean} - True if warning should be displayed
 */
export const shouldShowDevWarning = (user) => {
    // Check if user has "dev" role
    if (!user?.roles?.includes('dev')) {
        return false;
    }

    // Check if current URL is production (not localhost, 127.0.0.1, or contains "dev")
    const currentUrl = window.location.hostname;
    const isProduction = !currentUrl.includes('localhost') && 
                        !currentUrl.includes('127.0.0.1') && 
                        !currentUrl.includes('dev');

    return isProduction;
};